export default {
  items: [
    {
      label: 'Основная информация',
      url: '/',
      icon: 'fas fa-fw fa-lg fa-archive ',
      children: [
        {
          label: 'Главная страница',
          icon: 'fas fa-fw fa-lg fa-home',
          url: '/main'
        },
        {
          label: 'Лента новостей',
          icon: 'fas fa-fw fa-lg fa-newspaper',
          url: '/news_feed'
        },
        {
          label: 'Обучение',
          icon: 'fas  fa-fw fa-lg fa-book',
          url: '/education'
        },
        {
          label: 'Слет учащихся',
          icon: 'fas fa-lg fa-fw fa-user-friends',
          url: '/gathering'
        }
      ]
    },
    {
      label: 'Мой класс',
      url: '/class',
      icon: 'fas fa-fw fa-lg fa-book-open',
      permission: ['classroom-teacher', 'student'],
      children: [
        {
          label: 'Страница класса',
          icon: 'fas fa-fw fa-lg fa-chalkboard-teacher',
          url: '/class/content/class-page/current',
          permission: ['classroom-teacher', 'student']
        },
        {
          label: 'Список учеников',
          icon: 'fas fa-fw fa-lg fa-users',
          url: '/class/student/list',
          permission: ['classroom-teacher']
        },
        {
          label: 'Мероприятия',
          url: '/class/content/events',
          icon: 'fas fa-fw fa-lg fa-calendar',
          permission: ['classroom-teacher', 'student']
        }
      ]
    },
    {
      label: 'Профиль',
      url: '/profile',
      icon: 'fas fa-fw fa-lg fa-user'
    },
    {
      label: 'Абитуриенту',
      url: '/abiturient',
      icon: 'fas fa-fw fa-lg fa-book-open',
      permission: ['classroom-teacher', 'student', 'content-manager'],
      children: [
        {
          label: 'Выбор профессии',
          url: '/professions',
          icon: 'fas fa-fw fa-lg fa-user',
          permission: ['admin', 'curator'], //only for preview
          ids: [2731, 2723, 2737, 2728, 2729, 2732, 2138, 2948, 2923, 2937],
        },
        {
          label: 'Выбор вуза',
          url: '/university',
          icon: 'fas fa-fw fa-lg fa-university'
        },
      ]
    },
    {
      label: 'Администрирование',
      url: '/administration',
      icon: 'fas fa-fw fa-lg fa-users-cog',
      permission: ['admin'],
      children: [
        {
          label: 'Список пользователей',
          url: '/administration/users-list',
          icon: 'fas fa-lg fa-fw fa-user-friends',
          permission: ['admin']
        },
        {
          label: 'Список учеников',
          icon: 'fas fa-fw fa-lg fa-users',
          url: '/administration/student/list',
          permission: ['admin']
        },
        {
          label: 'Газпром-классы',
          icon: 'fas fa-lg fa-fw fa-school',
          url: '/administration/classes',
          permission: ['admin']
        },
        {
          label: 'Вузы и СПО',
          icon: 'fas fa-lg fa-fw fa-university',
          url: '/administration/universities',
          permission: ['admin']
        },
        {
          label: 'Подразделения',
          icon: 'fas fa-lg fa-fw fa-briefcase',
          url: '/administration/subdivisions',
          permission: ['admin']
        },
        {
          label: 'Галерея',
          url: '/administration/gallery',
          icon: 'fas fa-fw fa-lg fa-images',
          permission: ['admin']
        },
        {
          label: 'Настройки',
          url: '/administration/config',
          icon: 'fas fa-fw fa-lg fa-cog',
          permission: ['admin']
        }
      ]
    },
    {
      label: 'Настройка рекомендаций',
      url: '/administration/recommendation',
      icon: 'fas fa-fw fa-lg fa-sliders-h',
      permission: ['admin', 'content-manager'],
      ids: [78, 44, 2910],
      children: [
        {
          label: 'Предметы ЕГЭ',
          url: '/administration/recommendation/exams',
          icon: 'fas fa-lg fa-fw fa-book',
          permission: ['admin']
        },
        {
          label: 'Классификаторы направлений',
          url: '/administration/recommendation/dir-groups',
          icon: 'fas fa-lg fa-fw fa-sitemap',
          permission: ['admin']
        },
        {
          label: 'Направления',
          url: '/administration/recommendation/directions',
          icon: 'fas fa-lg fa-fw fa-layer-group',
          permission: ['admin']
        },
        {
          label: 'Направления вуза',
          url: '/administration/recommendation/dir-university',
          icon: 'fas fa-lg fa-fw fa-university',
          permission: ['admin', 'content-manager']
        },
        {
          label: 'Профессии',
          url: '/administration/recommendation/professions',
          icon: 'fas fa-user',
          permission: ['admin'], //only for preview
          ids: [78, 44, 2910]
        }
      ]
    },
    {
      label: 'Журналы',
      url: '/logs',
      icon: 'fas fa-lg fa-fw fa-book-open',
      permission: ['admin'],
      children: [
        {
          label: 'Журналы сервера',
          url: '/logs/server',
          icon: 'fas fa-fw fa-lg fa-server',
          permission: ['admin']
        },
        {
          label: 'Журналы активности',
          url: '/logs/activity',
          icon: 'fas fa-fw fa-lg fa-user-clock',
          permission: ['admin']
        },
        {
          label: 'История изменения состава студентов',
          url: '/logs/students',
          icon: 'fas fa-fw fa-lg fa-user-edit',
          permission: ['admin']
        }
      ]
    },
    {
      label: 'Контент',
      url: '/content',
      icon: 'fas fa-lg fa-fw fa-edit',
      permission: ['content-manager', 'verification-specialist'],
      children: [
        {
          label: 'Мероприятия',
          url: '/content/events',
          icon: 'fas fa-lg fa-fw fa-calendar',
          permission: ['content-manager']
        },
        {
          label: 'Новости',
          url: '/content/news',
          icon: 'fas fa-lg fa-fw fa-newspaper',
          permission: ['content-manager']
        },
        {
          label: 'Курсы',
          url: '/content/courses',
          icon: 'fas fa-lg fa-fw fa-book',
          permission: ['content-manager']
        },
        {
          label: 'Тренажеры',
          url: '/content/training',
          icon: 'fas fa-lg fa-fw fa-gamepad',
          permission: ['content-manager']
        },
        {
          label: 'Вузы-партнеры и учреждения СПО',
          url: '/content/partners',
          icon: 'fas fa-lg fa-fw fa-handshake',
          permission: ['content-manager']
        },
        {
          label: 'Газпром-классы',
          url: '/content/classes',
          icon: 'fas fa-lg fa-fw fa-university',
          permission: ['content-manager']
        },
        {
          label: 'Ожидают рассмотрения',
          url: '/content/await',
          icon: 'fas fa-lg fa-fw fa-clock',
          permission: ['verification-specialist']
        },
        {
          label: 'Подтверждено',
          url: '/content/accepted',
          icon: 'fas fa-lg fa-fw fa-check-circle',
          permission: ['verification-specialist']
        },
        {
          label: 'Отклонено',
          url: '/content/rejected',
          icon: 'fas fa-lg fa-fw fa-times-circle',
          permission: ['verification-specialist']
        },
        {
          label: 'Снято с публикации',
          url: '/content/removed',
          icon: 'fas fa-lg fa-fw fa-ban',
          permission: ['verification-specialist']
        }
      ]
    },
    // {
    //   label: 'Общение',
    //   icon: 'fas fa-fw fa-lg fa-comments',
    //   url: '/messages',
    //   children: [
    //     {
    //       label: 'Сообщения',
    //       icon: 'fas fa-fw fa-lg fa-envelope',
    //       url: '/messages/chats'
    //     },
    //     {
    //       label: 'Список контактов',
    //       icon: 'fas fa-fw fa-lg fa-address-book',
    //       url: '/messages/contacts'
    //     }
    //   ]
    // },
    {
      label: 'История изменений контента',
      icon: 'fas fa-fw fa-lg fa-tasks',
      url: '/history_of_content',
      permission: ['curator']
    },
    {
      label: 'Статистика',
      icon: 'fas fa-fw fa-lg fa-chart-bar',
      url: '/statistics',
      permission: ['curator']
    },
    {
      label: 'Классы',
      url: '/class',
      icon: 'fas fa-fw fa-lg fa-book-open',
      permission: ['curator'],
      children: [
        {
          label: 'Мероприятия',
          url: '/class/content/events',
          icon: 'fas fa-fw fa-lg fa-calendar',
          permission: ['curator']
        },
        {
          label: 'Список учеников',
          url: '/class/student/list',
          icon: 'fas fa-fw fa-lg fa-users',
          permission: ['curator']
        }
      ]
    }
  ]

}
